import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'

import { PercentTable } from '../../components/project-profit-sheet/PercentTable'
import { ppsSelector } from '../../selectors'
import { ppsAction } from '../../actions'
import { modalButtons } from '../../components/buttons/modal-button'
import { SimpleModal } from '../../components/modal/simple-modal'

export default forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const percentTable = useRef()

  const responseModal = useSelector(ppsSelector.responseModal)
  const updatedState = useSelector(ppsSelector.updatedProgresses)

  useEffect(() => {
    let response = {}
    let actions = {}
    if (updatedState && updatedState.status) response = updatedState

    if (response.status) {
      switch (response.type) {
        case 'error':
        case 'success': {
          actions = { close: closeResponseModal }
          break
        }
        default: break
      }

      dispatch(ppsAction.openResponseModal({
        is_open: true,
        res: {
          title: response.status,
          description: response.message,
          actions: modalButtons(response.type, actions),
        },
      }))
      dispatch(ppsAction.resetEditProgresses())
    }
  }, [updatedState.status])

  useImperativeHandle(ref, () => ({
    getProgressesData() {
      return percentTable.current.getProgressesData()
    },
    fetchProgressesData() {
      percentTable.current.fetchProgressesData()
    },
  }))

  const closeResponseModal = () => {
    dispatch(ppsAction.openResponseModal({ is_open: false, res: {} }))
  }

  return (
    <Root>
      <SimpleModal
        isOpen={ responseModal.is_open }
        toggle={ closeResponseModal }
        { ...responseModal.res }
      />
      <PercentTable
        ref={ percentTable }
        { ...props }
      />
    </Root>
  )
})

const Root = styled.div`
  height: calc(100% - 170px);
  overflow-y: auto;

  @media (max-width: 1440px) {
    height: calc(100% - 210px);
  }
`



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/percent.js